import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  ButtonGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { editQualityRating, updateQualityRating } from "../../../store/actions"

import { useEffect, useState } from "react"

const EditQualityRating = props => {
  const dispatch = useDispatch()
  document.title = "Edit Quality Rating"
  const { id } = useParams()

  const [details, setDetails] = useState({})

  useEffect(() => {
    dispatch(editQualityRating(id))
  }, [dispatch])

  const qualityRatings = useSelector(state => state.QualityRating)

  useEffect(() => {
    let rating = []
    if (
      qualityRatings &&
      qualityRatings.qualityRating &&
      qualityRatings.qualityRating.length > 0
    ) {
      rating = qualityRatings.qualityRating.filter(
        qualityRating => qualityRating.id == id
      )
    }
    if (rating.length > 0) {
      setDetails(rating[0])
    } else {
      props.history.push("/dropdown/quality_rating/list")
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      quality_rating_id:
        details && details.quality_rating_id ? details.quality_rating_id : "",

      quality_rating:
        details && details.quality_rating ? details.quality_rating : "",

      is_default: details && details.is_default ? 1 : 0,
    },
    validationSchema: Yup.object({
      quality_rating: Yup.string().required("Please enter category"),
    }),
    onSubmit: values => {
      values.quality_rating_id = id // quality_rating_id is from api thats why this needs to be same with "id"
      dispatch(updateQualityRating(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.QualityRating.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Edit Quality Rating" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editQualityRatingForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3 mt-1">
                          <Label htmlFor="rating-name">Quality Rating</Label>
                          <Input
                            name="quality_rating"
                            type="text"
                            id="rating-name"
                            placeholder="Enter quality rating"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.quality_rating || ""}
                          />
                          {validation.touched.quality_rating &&
                          validation.errors.quality_rating ? (
                            <FormFeedback type="invalid">
                              {validation.errors.quality_rating}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <h6>Default : </h6>
                      <ButtonGroup>
                        <Button
                          name="is_default"
                          color="success"
                          outline
                          value={1}
                          active={validation.values.is_default == 1}
                          onClick={validation.handleChange}
                        >
                          Yes
                        </Button>

                        <Button
                          name="is_default"
                          color="secondary"
                          outline
                          value={0}
                          active={validation.values.is_default == 0}
                          onClick={validation.handleChange}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </div>
                    <br />
                    <div>
                      {qualityRatings && qualityRatings.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Updating ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Update
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default EditQualityRating
